import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../../helpers/moment';

const DateTime = ({date, format}) => {
    return (<time dateTime={date}>{moment(date).format(format)}</time>)
}

DateTime.propTypes = {
    date: PropTypes.any.isRequired,
    format: PropTypes.string
}

DateTime.defaultProps = {
    format: 'DD/MM/YYYY'
}

export default DateTime



// WEBPACK FOOTER //
// ./src/components/_common/DateTime/index.js